export default {
      id: "feuilles_acces-usage",
      viewBox: "0 0 150 250",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#feuilles_acces-usage",
      toString: function () {
        return this.url;
      }
    }